/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListFineTuningJobsRequest = {
  after?: string | null | undefined;
  limit?: number | undefined;
};

/** @internal */
export const ListFineTuningJobsRequest$inboundSchema: z.ZodType<
  ListFineTuningJobsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  after: z.nullable(z.string()).optional(),
  limit: z.number().int().default(20),
});
/** @internal */
export type ListFineTuningJobsRequest$Outbound = {
  after?: string | null | undefined;
  limit: number;
};

/** @internal */
export const ListFineTuningJobsRequest$outboundSchema: z.ZodType<
  ListFineTuningJobsRequest$Outbound,
  z.ZodTypeDef,
  ListFineTuningJobsRequest
> = z.object({
  after: z.nullable(z.string()).optional(),
  limit: z.number().int().default(20),
});

export function listFineTuningJobsRequestToJSON(
  listFineTuningJobsRequest: ListFineTuningJobsRequest,
): string {
  return JSON.stringify(
    ListFineTuningJobsRequest$outboundSchema.parse(listFineTuningJobsRequest),
  );
}
export function listFineTuningJobsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListFineTuningJobsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListFineTuningJobsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListFineTuningJobsRequest' from JSON`,
  );
}
